import api from './index'

const resource = 'dev_sessions'

export default {
  getUsers () {
    return api.get(resource)
  }
}
